
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq7r5RtxREw9X2LeTpTjNb_45Pc3Bj6uGkwtNA2GIZ3iLpsMeta } from "/codebuild/output/src23910083/src/src/pages/faq.vue?macro=true";
import { default as menuqVxPyx87637SnyhxmlaQ7qGhXHtvqylOYC4VtIg8U1wMeta } from "/codebuild/output/src23910083/src/src/pages/menu.vue?macro=true";
import { default as indexSDBBkqRKEitydZQhCEr0tVQqAAGT2wiaS08FEFGR71YMeta } from "/codebuild/output/src23910083/src/src/pages/index.vue?macro=true";
import { default as contactZJvGKWRpm7tODwO_45i5rJ1ExgTaPqfHtHSUSrMqUzVEcMeta } from "/codebuild/output/src23910083/src/src/pages/contact.vue?macro=true";
import { default as tutorial_kxGDlkEaWllG0IwklLJy_45BxEgf8p0cuJmblh7Z8L4QMeta } from "/codebuild/output/src23910083/src/src/pages/tutorial.vue?macro=true";
import { default as agreementxvG7tqOwBI4wXScELSRwsyuaKSLWWQO9YheaB8tXkxMMeta } from "/codebuild/output/src23910083/src/src/pages/agreement.vue?macro=true";
import { default as about_45passPVsVOR74cA_TMTUpYn1uAcuUYI2x71HP6_45Rlp8WSNPAMeta } from "/codebuild/output/src23910083/src/src/pages/about-pass.vue?macro=true";
import { default as indexpT_45549aFOa6j64LZNkCW98PUncDY8_CEJhwiS658SnoMeta } from "/codebuild/output/src23910083/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93cpQ0GkEjRJO5eQT1WoGB0nZnuDhtjtMUNkHkx2adWwsMeta } from "/codebuild/output/src23910083/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancehx9YhG22fqaljN1A59W78UsFx8ejYTo7mcJiyfPjVE4Meta } from "/codebuild/output/src23910083/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93fOrMsHba0u_45E2Ey_45T3_9oBicPyj4_45_5zPDEH8h3_xakMeta } from "/codebuild/output/src23910083/src/src/pages/notice/[id].vue?macro=true";
import { default as indext_45YgS_45XWpVQ_459xh5LxngF1u4lijl2jtWjhA3Ww9nxnUMeta } from "/codebuild/output/src23910083/src/src/pages/coupon/index.vue?macro=true";
import { default as indexKJ7nDQYPHOPDyETlJyd1Mmil8_45dr1WiF4w2foI3qVXMMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/index.vue?macro=true";
import { default as indextQnbkid73wtPKj8Oa4gpjmsNhIAubEn8i7Gg78dxiw8Meta } from "/codebuild/output/src23910083/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93f0pNgWYdbcPkHV1dXWCxiXlIXwL5jSwUqA2T_2dFiAgMeta } from "/codebuild/output/src23910083/src/src/pages/parking/[id].vue?macro=true";
import { default as indexElX9ijmaG6JiimeRKyNtZnfszQWRbJzP5JQOGTspR6cMeta } from "/codebuild/output/src23910083/src/src/pages/history/index.vue?macro=true";
import { default as indexKUnQL4H1Z4ZItUTkkb2_uaHD8qh9eEEktHop38kIh78Meta } from "/codebuild/output/src23910083/src/src/pages/monthly/index.vue?macro=true";
import { default as indexlIlOaO4uzBXB8UU5SoHcILPTmK2HKn_ZsIoRNzanLEYMeta } from "/codebuild/output/src23910083/src/src/pages/sign-in/index.vue?macro=true";
import { default as indextAsbH6PLZ_1TIdLfq9FwCjuDdl0nEi4hmQ1s3Gp6rvEMeta } from "/codebuild/output/src23910083/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavijiPWV8zweb79jOZH_WBmXr8f_45sjuUboLOBWruc07LOQMeta } from "/codebuild/output/src23910083/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editZhLKxAbJDe_tUuvRHaSQWe3u9WZD34GRTXDXrUjswm8Meta } from "/codebuild/output/src23910083/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementdMCcU79kRSiAQvw_45Jmrlebg7w7uO6mN_45q9UlS8xNgHgMeta } from "/codebuild/output/src23910083/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexRld3dkY64QKYpb2BEUuBetMRWfn2FVUixVe5P9lyY4kMeta } from "/codebuild/output/src23910083/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dciayEP58RtlH9eiBP8mq2lIVAPC02MB9mMqR_45PRa9dsMeta } from "/codebuild/output/src23910083/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmjsCQ5beGedqjguo6LjGFmajgMrq5gy7MHm8ujSrAt0AMeta } from "/codebuild/output/src23910083/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexmlp2zmP9q4QP0eFiavVZcNysHl7Pb_vnSbydY_rQ5_8Meta } from "/codebuild/output/src23910083/src/src/pages/card/create/index.vue?macro=true";
import { default as indexZPhrU4yfM3w2d7WR2SYH7zYQTZg6zjlU_45HPXXDQDCSgMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmiO504o0YkpQ5mZFvB4HtRspMhgiH2H0LvQ2elp1iz4AMeta } from "/codebuild/output/src23910083/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmiSDkQk0ha8gbljg3IKq_05Mvrg1fE4eD8JksFkUi3UMMeta } from "/codebuild/output/src23910083/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completec0rX2PRZxQ_45tt4Vn5fnQD1ntUDUXHFOYHy4EOPdTcUIMeta } from "/codebuild/output/src23910083/src/src/pages/membership/complete.vue?macro=true";
import { default as registermwyfoHc4HkALTnOR036zVNsh_Hb7It7IrGRV5usP5m8Meta } from "/codebuild/output/src23910083/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93M9Fky6fdhqGMbsHZ_45M8SLqqE2ZeBALpNjpQe5c6lsVoMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm5KbIEDUYQfciLKRrB2w351FaoYEkKyVqVxwbJ8Xa5ZAMeta } from "/codebuild/output/src23910083/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93srKnx9or82RV6gHBahpeDk5lEklrOy7By6pXq4v2wSQMeta } from "/codebuild/output/src23910083/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index7hdCZA14dw1w_7B3wGWyyKni3s2vnbz_45h43joDYR72YMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeAl_CeZgH0bJ59H0mA8BSrjiFhOSS6kwFBrg_45Rt9Jtf4Meta } from "/codebuild/output/src23910083/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeHEo_Ld_miLZbfhJhV4qurfUtTFbdToAvEFM3v2gqEDYMeta } from "/codebuild/output/src23910083/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeF_45i1mMIP8qmyQcCzCRmC_458f1x91dc8Z6ZCBukHSZv1sMeta } from "/codebuild/output/src23910083/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerah5c8MTYx_eyUCtzx56D0fL_vRlQEEkRhZ3MYlbu6tEMeta } from "/codebuild/output/src23910083/src/src/pages/contact-form/register.vue?macro=true";
import { default as completen8spU2c41tCeZdhBGof8TRdFFYuIilgLBjr3VvsL7FYMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexKg3U0RJXEBONQAdU03_vUIAEqjZOEBHb_BjTaXLyEXgMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmw3aQNB4X9DsnGQ_JKxsTh_9A5pAwPBswTMm0E9NUgcAMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete1xfBucpHwiHIK_kw_45ejWB_so7oHEfikPS1VK1z3E_NsMeta } from "/codebuild/output/src23910083/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexe5d3y_OjZj4spcvr_cL_45oKbv6ixcD5nlQPMiOUx0fiIMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93hJ7Wzpe4ukZ2G_454sag_YovdQ6i5h30ZO_uK5JXpSQgMMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completew9AgpkFRP0ULuOpF_45WHVfErt6HX9cD0GbaGY0AYNsHkMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasK107D0mTL_45HPCobat721FHI36sBQOTxkFgPmPJDHsjoMeta } from "/codebuild/output/src23910083/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleTM0rMzX_45cOb5aUB9_45i1ZLFNrrNJnvmPVA9KRefbec8MMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailY07955NaZp28YeFARTVWmdu7w8Hqk5l9RJBF90wB2J4Meta } from "/codebuild/output/src23910083/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmpLZdCfnk0F9TNJg7mKmN7iqilfsDtI1PhMK8q8ArOwAMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent0PK421JfpU4A9cNb2bCQY7QV__mCsPN3AA2k24IfWtwMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_45rYTi8uBIXNMwNJrktlPhf6qt4__458pzcw1AyRlj7vEQMeta } from "/codebuild/output/src23910083/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatexaNIWpKXO2uEpcg3BBUNA0_45Ylk8sGccljrh_Q0bt0McMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeSJBePI8ywhUfLIyFhN80oaHjL1G78WNTdv2xWGJeW5EMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeO632dqSMos7_IU0dLDSx1GP8zaRXaNPNw6bJ_458KJUC0Meta } from "/codebuild/output/src23910083/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordI_45WL1cfi3PVUhTHpM9skoG3uD45_45DQPHTviUk17VongMeta } from "/codebuild/output/src23910083/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasu3hEHZw875SnIHK7SWcH1EQ84RzJIBRlHzHD7oKbpHQMeta } from "/codebuild/output/src23910083/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register0QbLtF2jLaY7BfqNZ98M_459anwHBHC2beNrbqtfv0cbAMeta } from "/codebuild/output/src23910083/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeKiJ0K0SpdcfzP_45kJ_45wnzl__45yMoEOwLI7y7zExD1YmEAMeta } from "/codebuild/output/src23910083/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexHwCS_45C8n_45jT8crZOt0LpHbNl6ctD5YL0EPzQnpI2E44Meta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexScBf42q5hjpkEvMrRkUtXuivKkB3dh_45RyZUpxzZPbLcMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index2yKL3ZaHtjnJWhw1lqliPXk3YU9Thk0_TtxzsHV0GAwMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexkbzDCKKFzhnEHlqOBD1O7agwjkMic3NMOs8Gyv2RNu0Meta } from "/codebuild/output/src23910083/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateOG4xxIbnyWlLlLPNypZoBuyfkMZtjhLfnJGHO0eGKrIMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeeq3kg5ntibwHKH5WOZGOmwoYIPGGBOC1IZccD0FHiacMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmWRtfXdbtxuvsKpA4vbmzC1Rsl28BmEllBT8u7xI6AesMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexnYcf_9Wq_4523A3PNQCzoi2PfLcjrvSOTTXY8wmW01W_IMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completezPnER3FyVACttUDYguolKu_45tQk_45Z_45x5vh0sKs81NyMAMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update4Jc3CpCyB9hOYGs5i__456ZUu776DPwXqAqkcopvR1PiQMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexw4_45yjhvMDJc4HvdSe1nmk8I4sR9OqtOf_TFUwAf0aC4Meta } from "/codebuild/output/src23910083/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexBdScVeUsSWg_45ZW3NXRpWRjkpuco4_45ZvA2A0ISIUK01MMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeV1C9g85hnryJSlsA_b_4pGjScSZcdYkY09coZuNus_MMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index1opBoxE2OmQXpoZ48tp4H42vy8Ssn8z6wb2kpwnjsEgMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeDZObiB9Oy1YB4lmqP_GlXm29xFGeL2Jze30foCm0lD0Meta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexQCNqPhcai7nHYwxbC7mQVjEXfthmdeN7IoBJ7Hq0TnwMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexzUWFuMW0RlLRRwrzyal2SipufPXqmp9J5knX93tzJ0QMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index2ww0wVmFPRcApF6EhWOUKcqAaMoNcIGH715LCAwgwzsMeta } from "/codebuild/output/src23910083/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateyHk73Fog7QLzYc2VmnPgOpH83KT1qjVN7MtT6rV_jcsMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmaYITZ7a9VaGmXa4bwMPgmBBF4VPk0JFbCfZRzAwOl1QMeta } from "/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src23910083/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuqVxPyx87637SnyhxmlaQ7qGhXHtvqylOYC4VtIg8U1wMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexSDBBkqRKEitydZQhCEr0tVQqAAGT2wiaS08FEFGR71YMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src23910083/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src23910083/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src23910083/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src23910083/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src23910083/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indext_45YgS_45XWpVQ_459xh5LxngF1u4lijl2jtWjhA3Ww9nxnUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexElX9ijmaG6JiimeRKyNtZnfszQWRbJzP5JQOGTspR6cMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexlIlOaO4uzBXB8UU5SoHcILPTmK2HKn_ZsIoRNzanLEYMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indextAsbH6PLZ_1TIdLfq9FwCjuDdl0nEi4hmQ1s3Gp6rvEMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src23910083/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src23910083/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexmlp2zmP9q4QP0eFiavVZcNysHl7Pb_vnSbydY_rQ5_8Meta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmiO504o0YkpQ5mZFvB4HtRspMhgiH2H0LvQ2elp1iz4AMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmiSDkQk0ha8gbljg3IKq_05Mvrg1fE4eD8JksFkUi3UMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completec0rX2PRZxQ_45tt4Vn5fnQD1ntUDUXHFOYHy4EOPdTcUIMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registermwyfoHc4HkALTnOR036zVNsh_Hb7It7IrGRV5usP5m8Meta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm5KbIEDUYQfciLKRrB2w351FaoYEkKyVqVxwbJ8Xa5ZAMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeAl_CeZgH0bJ59H0mA8BSrjiFhOSS6kwFBrg_45Rt9Jtf4Meta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeHEo_Ld_miLZbfhJhV4qurfUtTFbdToAvEFM3v2gqEDYMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeF_45i1mMIP8qmyQcCzCRmC_458f1x91dc8Z6ZCBukHSZv1sMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerah5c8MTYx_eyUCtzx56D0fL_vRlQEEkRhZ3MYlbu6tEMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmw3aQNB4X9DsnGQ_JKxsTh_9A5pAwPBswTMm0E9NUgcAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete1xfBucpHwiHIK_kw_45ejWB_so7oHEfikPS1VK1z3E_NsMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexe5d3y_OjZj4spcvr_cL_45oKbv6ixcD5nlQPMiOUx0fiIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completew9AgpkFRP0ULuOpF_45WHVfErt6HX9cD0GbaGY0AYNsHkMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleTM0rMzX_45cOb5aUB9_45i1ZLFNrrNJnvmPVA9KRefbec8MMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailY07955NaZp28YeFARTVWmdu7w8Hqk5l9RJBF90wB2J4Meta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmpLZdCfnk0F9TNJg7mKmN7iqilfsDtI1PhMK8q8ArOwAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent0PK421JfpU4A9cNb2bCQY7QV__mCsPN3AA2k24IfWtwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_45rYTi8uBIXNMwNJrktlPhf6qt4__458pzcw1AyRlj7vEQMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeSJBePI8ywhUfLIyFhN80oaHjL1G78WNTdv2xWGJeW5EMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeO632dqSMos7_IU0dLDSx1GP8zaRXaNPNw6bJ_458KJUC0Meta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordI_45WL1cfi3PVUhTHpM9skoG3uD45_45DQPHTviUk17VongMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src23910083/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register0QbLtF2jLaY7BfqNZ98M_459anwHBHC2beNrbqtfv0cbAMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeKiJ0K0SpdcfzP_45kJ_45wnzl__45yMoEOwLI7y7zExD1YmEAMeta || {},
    component: () => import("/codebuild/output/src23910083/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src23910083/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src23910083/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]